import { ax } from '@src/utils/axios/axios'
import { BASE_API_URL } from '@src/constants'

interface Options {
  monthOffset?: number
  depotId?: string
  stateId?: string
}

export interface ShiftCostItem {
  project_id: string
  project_name: string
  depot_id: string
  depot_name: string
  shift_id: number
  shift_date: string
  drs_summary_id: number
  drs_status_id: string | null
  project_revenue: number | null
  plan_project_revenue: number | null
  comments: string | null
  labour_cost: number
  material_cost: number
  subcontractor_cost: number
  mobile_asset_cost: number
  project_cost_items: number
  overhead_cost: number
  total_cost: number
  total_tonnes: number
  total_binder: number
  plan_labour_cost: number
  plan_material_cost: number
  plan_subcontractor_cost: number
  plan_mobile_asset_cost: number
  plan_project_cost_items: number
  plan_overhead_cost: number
  plan_total_cost: number
}

export interface ShiftCostSummary {
  totalShifts: number
  completedShifts: number
  plannedShifts: number
  cancelledShifts: number
  // Actual bucket (completed shifts)
  totalProjectRevenue: number
  totalLabourCost: number
  totalMaterialCost: number
  totalSubcontractorCost: number
  totalMobileAssetCost: number
  totalProjectCostItems: number
  totalOverheadCost: number
  grandTotalCost: number
  totalTonnes: number
  totalBinder: number
  // Plan bucket (planned shifts)
  totalPlanProjectRevenue: number
  totalPlanLabourCost: number
  totalPlanMaterialCost: number
  totalPlanSubcontractorCost: number
  totalPlanMobileAssetCost: number
  totalPlanProjectCostItems: number
  totalPlanOverheadCost: number
  grandPlanTotalCost: number
}

export interface ProjectShiftCostsResponse {
  shifts: ShiftCostItem[]
  summary: ShiftCostSummary
}

export const apiProjectShiftCosts = ({ monthOffset, depotId, stateId }: Options = {}) => {
  const params: any = {}

  if (monthOffset !== undefined) params.monthOffset = monthOffset
  if (depotId) params.depotId = depotId
  if (stateId) params.stateId = stateId

  return ax({
    method: 'GET',
    url: `${BASE_API_URL}/v2/reports/project-shift-costs`,
    params,
  })
}
